import { Aemet } from "./../types/aemet.type";
import { responseHandlerDefault } from "./../utils/handler.util";
import { Filter } from "./../types/filter.type";
import axios from "./api";
import { Pagination } from "./../types/pagination.type";

export const postAemet = (aemet: Aemet): Promise<Aemet> => {
  return axios.post<Aemet>("/aemet/", aemet).then(responseHandlerDefault);
};

export const getAemet = (
  page?: number,
  size?: number,
  filter?: Filter
): Promise<Pagination<Aemet>> => {
  const params: { page?: number; size?: number; filter?: Filter } = {};
  if (page) {
    params.page = page;
  }
  if (size) {
    params.size = size;
  }
  if (filter) {
    params.filter = filter;
  }
  return axios.get<Pagination<Aemet>>(`/aemet/`, { params }).then(responseHandlerDefault);
};
